/**
 * 站点设置 Hook
 * 提供全局站点信息和功能开关
 */

import { useQuery } from '@tanstack/react-query';
import { settingsAdapter } from '../adapters';

export function useSettings() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['settings'],
    queryFn: async () => {
      const result = await settingsAdapter.getSettings();
      return result.data;
    },
    staleTime: 30 * 60 * 1000, // 30分钟缓存
    retry: 1,
  });

  return {
    site: data?.site,
    features: data?.features,
    isLoading,
    error,
  };
}
